import styled from 'styled-components';
import { COLOR, mobile, STYLE } from './variables';
import { hexOpacity, invertHex } from '../utils/helper/styling';

export const Article = styled.article``;

export const H1 = styled.h1`
    font-family: Bold;
    font-size: 1.6rem;
    line-height: 1.3;
    margin-top: 0;
`;

export const H2 = styled.h2`
    font-family: SemiBold;
    font-size: 1.25rem;
    line-height: 1.3;
    margin: 1rem 0;
`;

export const H3 = styled.h3`
    font-size: 1rem;
    font-family: SemiBold;
`;

export const H4 = styled.h4`
    font-size: 1rem;
`;

export const H5 = styled.h5`
    font-size: 1rem;
`;

export const P = styled.p<{ light?: boolean }>`
    opacity: ${({ light }) => (light ? 0.55 : 1)};
    margin-top: 1.5em;
    margin-bottom: 2em;
`;

export const A = styled.a<{ light?: boolean }>`
    color: ${({ light }) => (light ? invertHex(COLOR.contentFont) : COLOR.contentFont)};
    opacity: 1 !important;
    text-decoration: underline;
    cursor: pointer;
`;

export const Strong = styled.strong`
    font-family: SemiBold;
`;

export const Section = styled.section`
    width: ${STYLE.content.width};
    max-width: ${STYLE.content.maxWidth};
    margin: 0 25% 4em 10%;
    color: ${COLOR.contentFont};

    @media ${mobile} {
        max-width: unset;
        margin-top: 0;
        margin-right: 0;
        margin-left: 0;
        width: 100%;
    }
`;

export const Block = styled.div<{ isOverlay?: boolean }>`
    position: relative;
    background-color: ${COLOR.contentBackground};
    margin-top: ${({ isOverlay }) => (isOverlay ? '-6rem' : `${STYLE.content.padding.top}`)};
    margin-right: ${STYLE.content.margin.right};
    margin-left: ${STYLE.content.margin.left};
    padding-top: ${({ isOverlay }) => (isOverlay ? `${STYLE.content.padding.top}` : '0')};
    padding-right: ${STYLE.content.padding.right};
    padding-bottom: ${STYLE.content.padding.bottom};
    padding-left: ${STYLE.content.padding.left};

    @media ${mobile} {
        margin-top: 0;
        padding-right: 0;
        padding-bottom: 0;
        padding-left: 0;
    }
`;

export const List = styled.ul`
    list-style: none;
    padding: 0;
`;

export const ListItem = styled.li``;

export const Column = styled.section`
    display: flex;
    flex-flow: column;
`;

export const Note = styled.div`
    text-align: right;
    padding: 0.15rem 0.5rem 0 0.5rem;
    font-size: 0.8rem;
    opacity: 0.5;
    color: ${COLOR.secondary};

    @media ${mobile} {
        margin-right: 2rem;
    }
`;

export const ErrorWrapper = styled.div`
    padding: 1em;
    margin-top: 1rem;
    border: 1px solid ${COLOR.error};
    background-color: ${hexOpacity(COLOR.error, 0.25)};
`;
